import { TEXT } from './00_assets_types'

const ES =
{
  [ TEXT.UI_MENU_USERS         ]: 'Uživatel'
, [ TEXT.UI_MENU_CLIENTS       ]: 'Klienti'
, [ TEXT.UI_MENU_WORKGROUPS    ]: 'Pracovní skupiny'
, [ TEXT.UI_MENU_JOBS          ]: 'Úkoly'
, [ TEXT.UI_MENU_KEY_MASTERING  ]: 'Systém hlavních klíčů'

, [ TEXT.UI_BUTTON_CREATE      ]: 'Vytvořit'
, [ TEXT.UI_BUTTON_NEW         ]: 'Nový'
, [ TEXT.UI_BUTTON_OK          ]: 'Ok'
, [ TEXT.UI_BUTTON_CANCEL      ]: 'Zrušení'
, [ TEXT.UI_BUTTON_SAVE        ]: 'Uložit'
, [ TEXT.UI_BUTTON_LOGIN       ]: 'Přihlásit se'
, [ TEXT.UI_BUTTON_SEND        ]: 'Poslat'


, [ TEXT.UI_EMAIL              ]: 'E-mailem'
, [ TEXT.UI_ROLE               ]: 'Role'
, [ TEXT.UI_USERNAME           ]: 'Uživatel'
, [ TEXT.UI_NAME               ]: 'Název'
, [ TEXT.UI_DATE               ]: 'Datum'
, [ TEXT.UI_ADDR               ]: 'Adresa'
, [ TEXT.UI_DESC               ]: 'Popis'
, [ TEXT.UI_PRICE              ]: 'Cena'
, [ TEXT.UI_NO_DATA            ]: 'Žádná data'
, [ TEXT.UI_MACHINES           ]: 'Stroje'
, [ TEXT.UI_USERS              ]: 'Uživatel'
, [ TEXT.UI_DATE_FORMAT        ]: 'DD/MM/YYYY' // ES - date format Locale
, [ TEXT.UI_SING_OUT           ]: 'Odhlásit se'
, [ TEXT.UI_MKS_TYPE           ]: 'Typ systému hlavních klíčů'
, [ TEXT.UI_KEY_APP            ]: 'Klíčové použití'
, [ TEXT.UI_CLIENT             ]: 'Klient'
, [ TEXT.UI_FILE               ]: 'Karta'
, [ TEXT.UI_SELECT_FILE        ]: 'Vyberte Karta'


, [ TEXT.UI_LOGIN_USERNAME     ]: 'Uživatelské jméno'
, [ TEXT.UI_LOGIN_CLOUDNAME    ]: 'Mrak'
, [ TEXT.UI_LOGIN_PASSWORD     ]: 'Heslo'



, [ TEXT.ARE_YOU_SURE          ]: 'Jsi si jistá?'


, [ TEXT.ERROR_NONE            ]: ''
, [ TEXT.ERROR_LOGIN_FORBIDDEN ]: 'Chybný uživatel / cloud nebo heslo'
, [ TEXT.ERROR_LOGIN_UNAUTHORIZED ]: 'Chybný uživatel / cloud nebo heslo'
, [ TEXT.ERROR_INTERNAL        ]: 'Interní chyba serveru'
, [ TEXT.ERROR_FORBIDDEN       ]: 'Přístup odepřen'
, [ TEXT.ERROR_UNKNOWN         ]: 'Došlo k chybě a to je vše, co víme'

, [ TEXT.PAGE_NOT_FOUND        ]: 'Stránka nenalezena'

, [ TEXT.WORKGROUPS_NEW_TITLE  ]: 'Nová pracovní skupina'
, [ TEXT.WORKGROUPS_EDIT_TITLE ]: 'Upravit pracovní skupinu'
, [ TEXT.WORKGROUPS_NAME       ]: 'Název'


, [ TEXT.USERS_NEW_TITLE       ]: 'Nový uživatel'
, [ TEXT.USERS_EDIT_TITLE      ]: 'Upravit uživatele'


, [ TEXT.MACHINE_TYPE          ]: 'Typ stroje'
, [ TEXT.MACHINE_NUM_JOBS      ]: '# úkoly'
, [ TEXT.MACHINE_NAME          ]: 'Stroj'


, [ TEXT.CLIENT_NEW_TITLE      ]: 'Nový klient'
, [ TEXT.CLIENT_EDIT_TITLE     ]: 'Upravit klienta'
, [ TEXT.CLIENT_ADDRESS        ]: 'Adresa'
, [ TEXT.CLIENT_CONTACT        ]: 'Kontakt'
, [ TEXT.CLIENT_CONTACT_EMAIL  ]: 'Email'
, [ TEXT.CLIENT_CONTACT_PHONE  ]: 'Telefon'
, [ TEXT.CLIENT_CONTACT_FAX    ]: 'Fax/Tlf'
, [ TEXT.CLIENT_SURNAMES       ]: 'Příjmení'
, [ TEXT.CLIENT_BIRTHDAY       ]: 'Narozeniny'
, [ TEXT.CLIENT_NOTES          ]: 'Poznámky'
, [ TEXT.CLIENTS_FILTER_BY_NAME ]: 'Název filtru'
, [ TEXT.CLIENTS_FILTER_BY_ADDR ]: 'Adresa filtru'
, [ TEXT.CLIENTS_FILTER_BY_CONTACT ]: 'Filtrovat kontakt'
, [ TEXT.CLIENT_ADDR_STREET1   ]: 'Adresa'
, [ TEXT.CLIENT_ADDR_STREET2   ]: ''
, [ TEXT.CLIENT_ADDR_CITY      ]: 'Město'
, [ TEXT.CLIENT_ADDR_PROVINCE  ]: 'Provincie'
, [ TEXT.CLIENT_ADDR_ZIP_CODE  ]: 'PSČ'
, [ TEXT.CLIENT_ADDR_COUNTRY   ]: 'Země'


, [ TEXT.MACHINES_NEW          ]: 'Nový stroj'
, [ TEXT.MACHINE_SERIAL_NO     ]: 'Sériové číslo'

, [ TEXT.JOB_EDIT_TITLE        ]: 'Upravit úlohu'
, [ TEXT.JOB_NEW_TITLE         ]: 'Nová úloha'
, [ TEXT.JOB_KEY_TYPE          ]: 'Typ klíče'
, [ TEXT.JOB_NUM_KEYS          ]: 'Množství'
, [ TEXT.JOB_MACHINE           ]: 'Stroj'
, [ TEXT.JOB_STATUS            ]: 'Postavení'
, [ TEXT.JOB_DATE              ]: 'Datum'
, [ TEXT.JOB_QUANTITY          ]: 'Nová částka'
, [ TEXT.JOB_FILTER_BY_STATUS  ]: 'Filtrovat podle stavu'
, [ TEXT.JOB_FILTER_BY_CLIENT  ]: 'Filtrovat klienty'
, [ TEXT.JOB_FILTER_BY_MACHINE_NAME ]: 'Filtrační stroj'
, [ TEXT.JOB_FILTER_BY_KEY_TYPE]: 'Filtrovat podle klíče'
, [ TEXT.JOB_FILTER_BY_DATE    ]: 'Filtrovat datum'

, [ TEXT.KEY_MASTERING_LAUNCH   ]: 'Start'
, [ TEXT.KEY_MASTERING_LAUNCH_N ]: 'Start ({num})'
, [ TEXT.KEY_MASTERING_NEW_TITLE ]: 'Nahrát systém hlavních klíčů'
, [ TEXT.KEY_MASTERING_WILL_CREATE_N_KEYS ]: 'Bude vytvořeno {num} klíčů. Jsi si jistá?'
, [ TEXT.KEY_MASTERING_KEYS_CREATED       ]: 'Bylo vytvořeno {num} pracovních míst'
, [ TEXT.KEY_MASTERING_NAME               ]: 'Název systému hlavního klíče'

, [ TEXT.LOGIN_FORGOT_PASSWORD_QUESTION ]: 'Zapomenuté heslo?'
, [ TEXT.LOGIN_FORGOT_PASSWORD_TITLE ]: 'Pokyny k odeslání odpočinku'
, [ TEXT.LOGIN_SLOGAN                   ]: 'První cloudová aplikace pro duplikování klíčů'
, [ TEXT.LOGIN_QUALITY_POINTS           ]: `
<br>
<br>
<p class="login-quality-call mb-4">
  <strong>THE FUTURE OF KEY DUPLICATION</strong>
</p>
<ul class="login-sell-points">
  <li>Zaregistrujte duplikáty klíčů, které byly vyrobeny pro vaše zákazníky</li>
  <br>
  <li>Ukládejte údaje bez rizika jejich ztráty a s možností přístupu k nim odkudkoliv</li>
  <br>
  <li>Automatické aktualizace</li>
</ul>
`

, [ TEXT.LEGAL_TOS_TEXT              ]: 'Právní upozornění'
, [ TEXT.LEGAL_PRIVACY_TEXT          ]: 'Zásady ochrany osobních údajů'
, [ TEXT.LEGAL_MODEL_TEXT            ]: 'Vzor dohody'
, [ TEXT.LEGAL_TOS_LINK              ]: '/legal/cs/legal_notice_cs.pdf'
, [ TEXT.LEGAL_PRIVACY_LINK          ]: '/legal/cs/privacy_policy_cs.pdf'
, [ TEXT.LEGAL_MODEL_LINK            ]: '/legal/cs/model_cs.docx'

, [ TEXT.KEY_MODEL                   ]: 'Klíč'
, [ TEXT.KEY_SERIES                  ]: 'Série'
, [ TEXT.KEY_CODE                    ]: 'Kód'
, [ TEXT.KEY_DATA_SHEET              ]: 'Kartu'
, [ TEXT.KEY_BITING                  ]: 'Kousání'
, [ TEXT.KEY_APPLICATION             ]: 'Aplikace'

, [ TEXT.ENUM_JOB_STATE_PENDING      ]: 'ČEKAJÍCÍ'
, [ TEXT.ENUM_JOB_STATE_CANCELLED    ]: 'ZRUŠENO'
, [ TEXT.ENUM_JOB_STATE_COMPLETE     ]: 'KOMPLETNÍ'
, [ TEXT.ENUM_JOB_STATE_PROCESSING   ]: 'ZPRACOVÁVÁ SE'

, [ TEXT.ENUM_USER_ROLE_ADMIN        ]: 'ADMIN'
, [ TEXT.ENUM_USER_ROLE_MANAGER      ]: 'MANAGER'
, [ TEXT.ENUM_USER_ROLE_USER         ]: 'USER'

, [ TEXT.ENUM_KEY_APP_CAR            ]: 'AUTO'
, [ TEXT.ENUM_KEY_APP_HOME           ]: 'DOMOV'
, [ TEXT.ENUM_KEY_APP_SECURITY       ]: 'BEZPEČNOSTNÍ'
, [ TEXT.ENUM_KEY_APP_LOCK           ]: 'VISACÍ ZÁMEK'
, [ TEXT.ENUM_KEY_APP_UNSPECIFIED    ]: 'NEPREDKLÁDANÉ'

, [ TEXT.FORM_HAS_ERRORS             ]: 'Vyplňte prosím povinná pole červeně'
}

export default ES ;
